<div class="container-full" style="margin-top:10px;">
	<div class="ace-heading-banner">
		<div style="padding-top:18px;">
			<span class="ace-heading-text-level-1" style="margin-left:25px;color:white;">GB Invoice Job Management</span>
		</div>
	</div>
	<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;min-height:600px;">
		<mat-card-content>
			<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:15px;">
				<strong>{{ jobs.length }} active job{{ jobs.length === 1 ? '' : 's' }}</strong>
				<button mat-raised-button color="primary" (click)="refreshJobs()" [disabled]="isLoading">Refresh</button>
			</div>
			<igx-grid [data]="jobs" [width]="'100%'" [height]="'500px'" [autoGenerate]="false">
				<igx-grid-toolbar>
					<igx-grid-toolbar-actions><igx-grid-toolbar-exporter></igx-grid-toolbar-exporter></igx-grid-toolbar-actions>
				</igx-grid-toolbar>
				<igx-column field="lotNumber" header="Lot Number" [sortable]="true"></igx-column>
				<igx-column field="jobId" header="Job ID" [sortable]="false"></igx-column>
				<igx-column field="processType" header="Process Type" [sortable]="true"></igx-column>
				<igx-column field="startedAt" header="Started At" [sortable]="true"><ng-template igxCell let-value>{{ formatDate(value) }}</ng-template></igx-column>
				<igx-column field="updatedAt" header="Updated At" [sortable]="true"><ng-template igxCell let-value>{{ formatDate(value) }}</ng-template></igx-column>
				<igx-column header="Actions" [sortable]="false" [filterable]="false" [width]="'180px'"><ng-template igxCell let-cell="cell"><button mat-stroked-button color="warn" (click)="releaseLock(cell.row.data)">Release Lock</button></ng-template></igx-column>
			</igx-grid>
		</mat-card-content>
	</mat-card>
</div>
